<template>
  <div class="column content-box full_page">
    <section>
        <woot-button
            v-if="selectedTab === 'sales'"
            color-scheme="success"
            class-names="button--fixed-right-top"
            icon="arrow-download"
            @click="downloadSaleReports"
        >
        {{$t('CATALOGUE.REPORTS.DOWNLOAD.SALES')}}
        </woot-button>
        <woot-button
            v-if="selectedTab === 'product'"
            color-scheme="success"
            class-names="button--fixed-right-top"
            icon="arrow-download"
            @click="downloadProductReports"
        >
        {{$t('CATALOGUE.REPORTS.DOWNLOAD.PRODUCTS')}}
        </woot-button>
        <woot-button
            v-if="selectedTab === 'coupons'"
            color-scheme="success"
            class-names="button--fixed-right-top"
            icon="arrow-download"
            @click="downloadCouponReport"
        >
        {{$t('CATALOGUE.REPORTS.DOWNLOAD.COUPONS')}}
        </woot-button>
    </section>
    <nav>
        <ul class="tab_list font_regular text_black_secondary font_500 text_14">
            <li
                v-for="tab in tabs"
                class="tab_item px_20 py_10"
                :class="tab.type === selectedTab ? 'isActive text_purple_primary' : ''"
                :key="tab.key"
                @click="onSubTabChange(tab)"
            >
                {{tab.name}}
            </li>
        </ul>
    </nav>
    <section class="tool_box">
        <!-- Toolbar Here -->
        <MultiselectDropdown
            :label="$t('CATALOGUE.REPORTS.TOOLS.DATE_RANGE.LABEL')"
        >
            <date-range-picker
                :confirm-text="$t('ORDER.LIST_TABLE.DATE_SELECT_CONFIRM_BTN')"
                :placeholder="$t('CATALOGUE.REPORTS.TOOLS.DATE_RANGE.PLACEHOLDER')"
                :value="dateRange"
                :displayFormat="'D MMM YYYY'"
                @change="handleDateChange"
                :disabledDate="disableFilterDate"
            />
        </MultiselectDropdown>
        <MultiselectDropdown
            v-if="selectedTab === 'coupons'"
            :label="$t('CATALOGUE.REPORTS.TOOLS.COUPON_BY.LABEL')"
            >
            <multiselect
                v-model="selectedCoupons"
                :options="couponDefaultList"
                class="small-12 font_normal"
                track-by="id"
                label="name"
                :multiple="true"
                :close-on-select="true"
                :clear-on-select="false"
                :hide-selected="true"
                :placeholder="$t('CATALOGUE.REPORTS.TOOLS.COUPON_BY.PLACEHOLDER')"
                selected-label
                :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
                :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
                @select="onCouponSelect($event)"
            />
        </MultiselectDropdown>
        <MultiselectDropdown
            v-if="selectedTab === 'coupons'"
            :label="$t('CATALOGUE.REPORTS.TOOLS.SORT_BY.LABEL')"
            >
            <RadioList
                v-model="sortByIndex"
                :options="sortByList"
                :classWrapper="'report_sort_options'"
                @change="onSortChange"
            />
        </MultiselectDropdown>


    </section>
    <section class="row">
        <!-- <div class="small-8 columns with-right-space ">
            <div class="sub_tabs">
                <div>
                    <ul class="tabs">
                        <li
                            v-for="tab in tabs"
                            class="tabs-title"
                            :class="tab.type === selectedTab ? 'is-active' : ''"
                            :key="tab.key"
                            @click="onSubTabChange(tab)"
                        >
                            <a>{{tab.name}}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div> -->
        <!-- <div class="small-4 columns with-left-space ">
            <div style="text-align:right;">
                <woot-button
                    v-if="selectedTab === 'sales'"
                    color-scheme="success"
                    class-names="button--fixed-right-top"
                    icon="arrow-download"
                    @click="downloadSaleReports"
                >
                Download sales report
                </woot-button>
                <woot-button
                    v-if="selectedTab === 'product'"
                    color-scheme="success"
                    class-names="button--fixed-right-top"
                    icon="arrow-download"
                    @click="downloadProductReports"
                >
                Download product report
                </woot-button>
                <date-range-picker
                    v-if="selectedTab === 'product' || selectedTab === 'sales'"
                    :confirm-text="$t('ORDER.LIST_TABLE.DATE_SELECT_CONFIRM_BTN')"
                    :placeholder="$t('ORDER.LIST_TABLE.DATE_SELECT_PLACEHOLDER')"
                    :value="dateRange"
                    @change="handleDateChange"
                    :disabledDate="disableFilterDate"
                />
            </div>
        </div> -->
    </section>

    <template>
        <SalesReport
            v-if="selectedTab === 'sales'"
            :isLoading="uiFlags.isFetching"
            :reports="salseReports"
            @on-sort-change="onSortChangeSales"
            :all_reports="salseReportsAll"
            :currency="currentUser.default_currency"
        />
        <ProductReport
            v-else-if="selectedTab === 'product'"
            :isLoading="uiFlags.isFetching"
            :reports="productReports"
            @on-sort-change="onSortChangeProduct"
            :all_reports="productReportsAll"
            :currency="currentUser.default_currency"
        />
        <CouponReport
            v-else-if="selectedTab === 'coupons'"
            :isLoading="coupon_uiFlags.isFetching"
            :reports="couponReports"
            :all_reports="productReportsAll"
            :currency="currentUser.default_currency"
            :sortBy="sortByList[sortByIndex]"
            @on-sort-change="onSortChangeProduct"
        />
        <div class="loadMore_btn">
          <woot-button
            v-if="selectedTab === 'sales'"
            variant="clear"
            size="small"
            color-scheme="primary"
            :is-loading="uiFlags.isFetching"
            :is-disabled="paginationCompute.isLastPage"
            @click="onPageChangeSales(Number(salesMeta.currentPage)+1)"
          >
            {{paginationCompute.btnText}}
          </woot-button>
          <woot-button
            v-else-if="selectedTab === 'product'"
            variant="clear"
            size="small"
            color-scheme="primary"
            :is-loading="uiFlags.isFetching"
            :is-disabled="paginationCompute.isLastPage"
            @click="onPageChangeProduct(Number(productMeta.currentPage)+1)"
          >
            {{paginationCompute.btnText}}
          </woot-button>
          <woot-button
            v-else-if="selectedTab === 'coupons'"
            variant="clear"
            size="small"
            color-scheme="primary"
            :is-loading="uiFlags.isFetching"
            :is-disabled="paginationCompute.isLastPage"
            @click="onPageChangeProduct(Number(productMeta.currentPage)+1)"
          >
            {{paginationCompute.btnText}}
          </woot-button>
        </div>
    </template>

  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import fromUnixTime from 'date-fns/fromUnixTime';
import format from 'date-fns/format';
import ProductReport from "./ProductReport/ProductReport.vue"
import SalesReport from "./SalesReport/SalesReport.vue"
import CouponReport from "./CouponReport/CouponReport.vue"
import DateRangePicker from "../../../../../dashboard/components/ui/DateRangePicker.vue"
import MerchantAPI from "../../../../api/merchant";
import MultiselectDropdown from "../../../../components/ui/inputs/MultiselectDropdown.vue"
import RadioList from "../../../dashboard/arrange/RadioList.vue"
import helperMixin from 'shared/mixins/helperMixin';

export default {
    components:{
        SalesReport,
        ProductReport,
        CouponReport,
        DateRangePicker,
        MultiselectDropdown,
        RadioList,
    },
    mixins: [helperMixin],
    data(){
        const endDate = new Date(); // Current date
        const startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 1); // One month ago
        return {
            merchant:{},
            tabs:[
                {key:0, name:'Sales',type:"sales",},
                {key:1, name:'Products',type:"product",},
                {key:2, name:'Coupons',type:"coupons",},
            ],
            selectedTab: 'sales',
            dateRange: [startDate,endDate],
            sortInfoSales:{
                sortBy: 'date',
                sortOrder: 'desc'
            },
            sortInfoProducts:{
                sortBy: 'date',
                sortOrder: 'desc'
            },
            sortByIndex: 0,
            selectedCoupons:[],
        }
    },
    computed:{
        ...mapGetters({
            currentUser: 'getCurrentUser',
            uiFlags: "orders/getUIFlags",
            salesMeta: "orders/getReportsSalesMeta",
            salseReportsAll: "orders/getSalesReports",
            salseReports: "orders/getPaginatedSalesReports",
            productMeta: "orders/getReportsProductMeta",
            productReportsAll: "orders/getProductReports",
            productReports: "orders/getPaginatedProductReports",
            // coupon report
            coupon_uiFlags: "coupons/getUIFlags",
            // couponMeta: "orders/getReportsCouponMeta",
            // couponReportsAll: "orders/getCouponReports",
            couponReports: "coupons/getCouponReports",
            couponDefaultList: "coupons/getDefaultCouponList",

        }),
        paginationCompute(){
            if (this.selectedTab === 'product') {
                const totalPages = Math.ceil(this.productMeta.count / this.productMeta.pageSize);
                const isLastPage = this.productMeta.currentPage >= totalPages;
                const currentCount = Math.min(this.productMeta.currentPage * this.productMeta.pageSize, this.productMeta.count);
                const btnText = `Load More (${currentCount}/${this.productMeta.count})`;

                return{
                    isLastPage,
                    btnText,
                }
            }else{
                const totalPages = Math.ceil(this.salesMeta.count / this.salesMeta.pageSize);
                const isLastPage = this.salesMeta.currentPage >= totalPages;
                const currentCount = Math.min(this.salesMeta.currentPage * this.salesMeta.pageSize, this.salesMeta.count);
                const btnText = `Load More (${currentCount}/${this.salesMeta.count})`;

                return{
                    isLastPage,
                    btnText,
                }
            }
        },
        sortByList(){
            return [
                {
                    id: 1,
                    label: this.$t('CATALOGUE.REPORTS.TOOLS.SORT_BY.VOLUME'),sortBy:"volume",sortOrder: 'desc',kind:"report_by_volumes"},
                {id: 2,label: this.$t('CATALOGUE.REPORTS.TOOLS.SORT_BY.VALUE'),sortBy:"value",sortOrder: 'desc',kind:"report_by_values"},
            ]
        },
    },
    mounted(){
        // this.$store.dispatch("orders/getSalesReports",{type:'sales',start_date:'2024-01-01',end_date:'2024-05-30'})
        this.handleDateChange(this.dateRange)
        // this.getReportByType(this.selectedTab)
        this.getMerchant()
    },
    methods:{
        onSubTabChange(tab){
            this.selectedTab = tab.type;
            this.handleDateChange(this.dateRange);
            // fetch coupon
            if (tab.type === 'coupons') {
                this.fetchCoupons({});
            }
        },
        /*
        getReportByType(type,start_date,end_date){
            // this.$store.dispatch("orders/getReports",{type:'sales',start_date:'2024-01-01',end_date:'2024-05-21'})
            this.$store.dispatch("orders/getReports",{type,start_date,end_date})
        },
        */
        async handleDateChange(dateRange) {
            this.dateRange = dateRange

            const date = this.formatStartEndDate(dateRange[0],dateRange[1]);
            console.log({dateRange,date});
            if (this.selectedTab === 'product') {
                await this.$store.dispatch("orders/getProductReports",{
                    type:'product',
                    start_date: date.start_date,
                    end_date: date.end_date
                });
               this.onPageChangeProduct(1)
            }
            else if(this.selectedTab  === 'coupons'){
                await this.$store.dispatch("coupons/getCouponReports",{
                    kind: this.sortByList[this.sortByIndex].kind, // send kind
                    start_date: date.start_date,
                    end_date: date.end_date,
                    coupon_ids: this.selectedCoupons.map(el=>el.id)?.join(','),
                });
               this.onPageChangeProduct(1)
            }
            else {
                await this.$store.dispatch("orders/getSalesReports",{
                    type:'sales',
                    start_date: date.start_date,
                    end_date: date.end_date
                });
               this.onPageChangeSales(1)

            }

        },
        disableFilterDate(date,currentValues){
            const today = new Date();
            const threeMonthsAgo = new Date();
            threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3); // 3 months ago

            if (date > today) {
                return true;
            }

            if (date < threeMonthsAgo) {
                return true;
            }
            return false;
        },
        formatStartEndDate(startDate,endDate){
            const providedStartDate = new Date(startDate);
            const providedEndDate = new Date(endDate);
            const option = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            }
            const formattedStartDate = providedStartDate.toLocaleDateString('fr-CA', option);
            const formattedEndDate = providedEndDate.toLocaleDateString('fr-CA', option);

            return {
                start_date: formattedStartDate,
                end_date: formattedEndDate,
            };
        },
        onPageChangeSales(page,option={}) {
            // console.log("ck",{page,option});

            this.$store.dispatch("orders/getPaginatedSalesReports",{
                currentPage:page,
                pageSize:this.salesMeta.pageSize,
                sortBy: this.sortInfoSales.sortBy,
                sortOrder: this.sortInfoSales.sortOrder,
            })
        },
        onPageChangeProduct(page,option={}) {
            // console.log("ck",{page,option});

            this.$store.dispatch("orders/getPaginatedProductReports",{
                currentPage:page,
                pageSize:this.productMeta.pageSize,
                sortBy: this.sortInfoProducts.sortBy,
                sortOrder: this.sortInfoProducts.sortOrder,
            })
        },
        onSortChangeSales(params){
            let newSort = {
                sortBy: 'date',  // default sort
                sortOrder: 'desc'
            }
            Object.keys(params).forEach(key=>{
                if (params[key]) {
                newSort.sortBy = key;
                newSort.sortOrder = params[key];
                }
            })
            this.sortInfoSales = newSort;
            this.onPageChangeSales(1)
        },
        onSortChangeProduct(params){
            let newSort = {
                sortBy: 'date',  // default sort
                sortOrder: 'desc'
            }
            Object.keys(params).forEach(key=>{
                if (params[key]) {
                newSort.sortBy = key;
                newSort.sortOrder = params[key];
                }
            })
            this.sortInfoProducts = newSort;
            this.onPageChangeProduct(1)
        },
        downloadSaleReports(){
            console.log("sale report = ",this.salseReportsAll);
            const {start_date,end_date} = this.formatStartEndDate(this.dateRange[0],this.dateRange[1]);

            console.log({start_date,end_date});
            const fileName = `sales-report-${start_date}.csv`;
            console.log({fileName});
            // Filter out the required columns
            const filteredData = this.salseReportsAll.map(record => ({
                date: record.date,
                amount: record.amount
            }));

            // Convert to CSV
            const headers = ['date', 'amount'];
            const csvContent = [
                headers.join(','), // header row first
                ...filteredData.map(item => [item.date, item.amount].join(',')), // data rows
                "", // empty row
                `Reporting period ${start_date} to ${end_date}`
            ].join('\n');

            // Create a Blob from the CSV content
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

            // Create a link to download the Blob
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        },
        downloadProductReports(){
            console.log("sale report = ",this.productReportsAll);
            const {start_date,end_date} = this.formatStartEndDate(this.dateRange[0],this.dateRange[1]);

            console.log({start_date,end_date});
            const fileName = `product-report-${start_date}.csv`;
            console.log({fileName});
            // Filter out the required columns
            const filteredData = this.productReportsAll.map(record => ({
                title: record.title,
                amount: record.amount
            }));

            // Convert to CSV
            const headers = ['title', 'amount'];
            const csvContent = [
                headers.join(','), // header row first
                ...filteredData.map(item => [item.title, item.amount].join(',')), // data rows
                "", // empty row
                `Reporting period ${start_date} to ${end_date}`
            ].join('\n');

            // Create a Blob from the CSV content
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

            // Create a link to download the Blob
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        },
        downloadCouponReport() {
                const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
                const headers = ['Day', 'Redeem', 'Not redeem'];

                const rows = days.map(day => {
                const redeem = this.couponReports?.[day]?.redeem ?? 0;
                const notRedeem = this.couponReports?.[day]?.['not-redeem'] ?? 0;
                return [
                        day.charAt(0).toUpperCase() + day.slice(1),
                        redeem,
                        notRedeem
                    ];
                });

                const csvContent = [headers, ...rows]
                .map(e => e.join(','))
                .join('\n');

                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.setAttribute("href", url);
                link.setAttribute("download", "coupon_report.csv");
                link.click();
        },
        async getMerchant(){
            try {
                const {data} = await MerchantAPI.getMerchantByName("");
                this.merchant = data;
            } catch (error) {
                console.log(error);
                this.showAlert(this.$t('ORDER.DETAILS.ALERT_MSG.FETCH_MERCHANT_FAIL'));
            }
        },
        async onSortChange(selectedIndex){
            await this.$nextTick();
            console.log({selectedIndex});
            this.handleDateChange(this.dateRange);
        },
        fetchCoupons(){
            // fetch list
            this.$store.dispatch("coupons/fetchDefaultCoupons");
        },
        async onCouponSelect(item){
            console.log({item},this.selectedCoupons);
            await this.$nextTick();
            console.log("after tik",this.selectedCoupons);
            this.handleDateChange(this.dateRange);
        },
        // methods end
    },
}
</script>

<style scoped lang="scss">
@import '~dashboard/assets/scss/widgets/_fonts.scss';

.loadMore_btn button{
  display: block;
  margin: auto;
}
.tab_list{
    display: flex;
    list-style: none;
    .tab_item{
        border-radius: 6px;
        cursor: pointer;
    }
}
.isActive{
    background: #F2E7FE;
}
.tool_box{
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

}
</style>
<style>
.tool_box .date-picker .mx-input-wrapper input{
    height: 4.0rem;
}
.tool_box .report_sort_options {
    display: flex;
    gap: 24px;
}
.tool_box .report_sort_options .radio-item{
    gap: 4px;
    margin-top: 7px;
}
.tool_box .report_sort_options input{
    margin-bottom: 0;
}
.tool_box .report_sort_options .radio_label{
    font-family: 'Figtree', sans-serif;
    font-weight: 500;
    font-size: 14px;
    color: #304352;
}
</style>